import React from 'react';
import { simpleIconPropsTypes } from '../propTypes';

export const IconCalendarClock = (props) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M8 21H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3" />
      <path d="M8 2v4M16 2v4M3 9h7" />
      <circle cx="17" cy="17" r="5" />
      <path d="M17 15v2l1.5 1" />
    </svg>
  );
};

IconCalendarClock.propTypes = simpleIconPropsTypes;
